/** 基础运营管理系统 **/

import Layout from "@/views/layout/Layout";

const dataCenterRouter = {
  path: "/dataCenter",
  component: Layout,
  name: "dataCenter",
  meta: {
    title: "数据中心",
    icon: "sjzx",
    roles: ["shujuzhongxin"]
  },
  children: [
    {
      path: "dataCenterScreen",
      component: () => import("@/views/dataCenter/dataCenterScreen"),
      name: "数据中心大屏",
      meta: {
        title: "数据中心大屏",
        roles: ["shujuzhongxindaping"]
      }
    },
    {
      path: "bigScreen",
      component: () => import("@/views/equipSafeMan/bigScreen/index"),
      name: "综合运行监控",
      alwaysShow: true,
      meta: {
        title: "综合运行监控",
        roles: ["sjzx_zongheyunxingjiankong"]
      },
      
      children: []
    },
    {
      path: "abnormalAlarmMan",
      component: () => import("@/views/equipSafeMan/abnormalAlarmMan"),
      name: "异常告警管理",
      alwaysShow: true,
      meta: {
        title: "异常告警管理",
        roles: ["sjzx_yichangbaojingguanli"]
      },
      children: []
    },
    {
      path: "operatingParameter",
      component: () => import("@/views/equipSafeMan/operatingParameter"),
      name: "运行参数监控",
      alwaysShow: true,
      meta: {
        title: "运行参数监控",
        roles: ["sjzx_yunxingcanshu"]
      },
      children: []
    },
       {
      path: "scene",
      component: () => import("@/views/equipSafeMan/scene"),
      name: "综合运行监控3D",
      meta: {
        title: "综合运行监控3D",
        roles: ["zongheyunxingjiankong3d"]  // zongheyunxingjiankong3d
      }
    },
       {
      path: "realTimeMonitoring3D",
      component: () => import("@/views/leftMan/realTimeMonitoring3D"),
      name: "实时监控3D",
      meta: {
        title: "实时监控3D",
        roles: ["shishijiankong3d"]
      }
    },
  ]
};

export default dataCenterRouter;
